import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { Link } from '@atlassian/react-resource-router';

type Props = {
	issueKey: IssueKey;
	issueTypeIconUrl: string;
	summary: string;
};

const SummaryCell = ({ issueKey, summary, issueTypeIconUrl }: Props) => (
	<Container>
		<IssueTypeIcon src={issueTypeIconUrl} />
		<IssueKeyLink href={`/browse/${issueKey}`} target="_blank">
			{issueKey}
		</IssueKeyLink>
		<IssueSummary>{summary}</IssueSummary>
	</Container>
);

export default SummaryCell;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueTypeIcon = styled.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 2}px`,
	marginTop: 0,
	marginRight: token('space.100', '8px'),
	marginBottom: 0,
	marginLeft: 0,
	borderRadius: '2px',
	flex: '0 0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueSummary = styled.span({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueKeyLink = styled(Link)({
	flexShrink: 0,
	marginRight: token('space.100', '8px'),
});
